/**
 * Route for `report-export` — "Exports" page. Registered via createRoute.
 * Root wires this into router.tsx post-merge.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ReportExportPage } from "../features/report-export/ReportExportPage";

export const reportExportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/report-export",
	component: ReportExportPage,
});

export default reportExportRoute;
